module.exports = __webpack_public_path__ + "img/sepa.4c7890ed.png";